import { type FC, useMemo } from 'react';

import times from 'lodash/times';

import { Flex } from '@/components/common/Flex';
import { Select, type SelectItem } from '@/components/common/select/Select';
import { Text } from '@/components/common/Text';
import dayjs from '@/utils/dayjs';

import styles from './DatePickerTimeSelect.module.scss';

type TimeSelectProps = {
  date?: Date;
  value?: string;
  onChange?: (time: string) => void;
  onChangeDate?: (date: Date) => void;
};

const pad = (value: number) => String(value).padStart(2, '0');

export const DatePickerTimeSelect: FC<TimeSelectProps> = (props) => {
  const { date, onChangeDate } = props;

  const dayjsDate = dayjs(date);

  const hoursOptions = useMemo((): SelectItem<number>[] => {
    return times(24, (hour) => ({
      value: hour,
      node: pad(hour),
    }));
  }, []);

  const minutesOptions = useMemo((): SelectItem<number>[] => {
    return times(60, (minute) => ({
      value: minute,
      node: pad(minute),
    }));
  }, []);

  const secondsOptions = useMemo((): SelectItem<number>[] => {
    return times(60, (second) => ({
      value: second,
      node: pad(second),
    }));
  }, []);

  return (
    <Flex className={styles.root} alignItems="center" justifyContent="spaceBetween">
      <Select
        value={dayjsDate.hour()}
        options={hoursOptions}
        menuPlacement="top"
        onChange={(hours) => {
          onChangeDate?.(dayjsDate.hour(hours).toDate());
        }}
      />

      <Text type="regular14" color="white-50p">
        :
      </Text>

      <Select
        value={dayjsDate.minute()}
        options={minutesOptions}
        menuPlacement="top"
        onChange={(minutes) => {
          onChangeDate?.(dayjsDate.minute(minutes).toDate());
        }}
      />

      <Text type="regular14" color="white-50p">
        :
      </Text>

      <Select
        value={dayjsDate.second()}
        options={secondsOptions}
        menuPlacement="top"
        onChange={(seconds) => {
          onChangeDate?.(dayjsDate.second(seconds).toDate());
        }}
      />
    </Flex>
  );
};
